import script from "./ViewMoreButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMoreButton.vue?vue&type=script&setup=true&lang=js"

import "./ViewMoreButton.vue?vue&type=style&index=0&id=eea6c788&lang=css"

const __exports__ = script;

export default __exports__